import React from 'react'
import style from './DotsLoader.module.css'


export default function DotsLoader(props) {

    let c={background:props.color || '#000'}

  return (
   <div className={style.gooeyContainer}>
    <div className={style.gooey}>
     <div style={c} className={style.dotElasticBefore}></div>
     <div style={c} className={style.dotElastic}></div>
     <div style={c} className={style.dotElasticAfter}></div>
     </div>
    </div>
  )
}
